import { initialState } from "./state"

export default {
  reset: state => {
    const init_state = initialState()
    Object.keys(state).forEach(key => {
      state[key] = init_state[key]
    })
  },
  setSurvey: (state, survey) => {
    state.questions = survey.questions
    delete survey.questions
    state.survey = survey
  },
  setSurveyName: (state, name) => (state.survey.name = name),
  setSurveyCategory: (state, category) => (state.survey.category = category),
  setSurveyStatus: (state, status) => (state.survey.status = status),
  setQuestionsList: (state, questions) => (state.questions = [...questions]),
  addQuestion: (state, question) =>
    state.questions.push({
      ...question,
      order: question.order || state.questions.length + 1
    }),
  editQuestion: (state, question) => {
    state.questions[question.order - 1] = question
    state.questions = [...state.questions]
  },
  removeQuestionByIndex: (state, index) =>
    (state.questions = state.questions
      .filter((e, i) => index != i)
      .map((e, index) => ({ ...e, order: index + 1 })))
}
